import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface seoState {
  seoData: null | any;
}

const initialState: seoState = {
  seoData: null,
};

const seoSlice = createSlice({
  name: "seo",
  initialState,
  reducers: {
    getSeoData(state, action: PayloadAction<any>) {
      state.seoData = action.payload;
    },
  },
});

export const { getSeoData } = seoSlice.actions;
export default seoSlice.reducer;
